var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PagedCollection } from "@auvious/common";
export class ApiQueryResource {
    constructor(common) {
        this.apiResource = common.apiResourceFactory("/api/asr/");
    }
    getLatestConfiguration(conferenceId) {
        return this.apiResource.get({
            urlPostfix: `/${conferenceId}/latest`,
        });
    }
    getOrganizationAvailableLanguages(page, pageSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams();
            params.set("page", page.toString());
            params.set("size", pageSize.toString());
            return new PagedCollection(yield this.apiResource.get({
                params,
                urlPostfix: "/languages",
            }));
        });
    }
    getSpeechToTextProviderAvailableLanguages() {
        return this.apiResource.get({
            urlPostfix: `/languages/available`,
        });
    }
    getSpeechToTextProviderAvailableLanguagesByProvider(providerType) {
        return this.apiResource.get({
            urlPostfix: `/${providerType}/languages/available`,
        });
    }
    getTranslateProviderTargetLanguages(type, applicationId, languageCode) {
        return this.apiResource.get({
            urlPostfix: `/${type}/${applicationId}/${languageCode}/languages/target`,
        });
    }
}
